<template>
    <div class="animated fadeIn">
        <div class="card" style="margin:0px 15px 10px 15px">
            <div class="row" style="padding: 20px;background-color:#fff">
                <div class="col-md-8">
                    <p style="font-size: 16px;">This pages shows the information of a customer</p>
                </div>
                <div class="col-md-4">
                    <p class="text-right">
                        <b-link v-show="!loading" @click="goBack()">
                            <span class="fa fa-arrow-left"></span> Return Back
                        </b-link>
                    </p>
                </div>
            </div>
        </div>
        <b-row>
            <b-col cols="12" lg="12">
                <b-alert variant="danger" :show="hasError">{{ error }} </b-alert>
                <p v-if="loading" style="text-align: center;padding: 20px">
                    <span style="font-size: 25px;">
                        <i class="fa fa-spinner fa-spin"></i> Loading ...
                    </span>
                </p>
                <div v-else>
                    <b-card :header="`${customerDetails.first_name} ${customerDetails.last_name} Details`"> 
                        <form @submit.prevent="updateCustomerDetails">
                        <b-row>
                            <b-col lg="3" md="3" sm="12" xs="12">
                                <p class="text-center" title="Click to change photo">
                                    <img v-if="userDetails.profile_image === null" src="../../assets/images/man.png" alt="profile-image" />
                                    <img v-else-if="profile_image !== ''" :src="profile_image" alt="profile-image" class="rounded-circle img-response" width="150"/>
                                    <img v-else src="../../assets/images/man.png" alt="profile-image" />
                                </p><hr/>
                                <b-list-group style="margin-bottom: 20px">
                                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                                        <strong>Name:</strong>
                                        <strong>{{`${customerDetails.first_name.toUpperCase()} ${customerDetails.last_name.toUpperCase()}`}}</strong>
                                    </b-list-group-item>
                                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                                        <strong>Status:</strong>
                                        <b-badge v-if="userDetails.is_active === 1" variant="success" pill>Active</b-badge>
                                        <b-badge v-else variant="warning" pill>Inactive</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                                        <strong>Personal Email:</strong>
                                        <b-badge v-if="userDetails.email_verified_at === null" variant="danger" pill>Unverified</b-badge>
                                        <b-badge v-else variant="success" pill>Verified</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                                        <strong>Work Email</strong>
                                        <b-badge v-if="userDetails.work_email_verified_at === null" variant="danger" pill>Unverified</b-badge>
                                        <b-badge v-else variant="success" pill>Verified</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="access.includes(role)" class="d-flex justify-content-between align-items-center">
                                        <span v-if="sending"><i class="fa fa-spinner fa-spin"></i> please wait ...</span>
                                        <button title="Click here to resent activation link" v-else @click="resendActivation" type="button" class="btn btn-sm btn-default" ><i class="fa fa-refresh"></i> Resent activation mail</button>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="access.includes(role)" class="d-flex justify-content-between align-items-center">
                                        <span v-if="sending"><i class="fa fa-spinner fa-spin"></i> please wait ...</span>
                                        <b-button v-b-modal.modal-1>Edit Login Details</b-button>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col lg="9" md="9" sm="12" xs="12">
                                <b-list-group>
                                        <b-list-group-item active>BVN Information</b-list-group-item>
                                        <b-list-group-item >
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="First Name" label-for="normalEmail">
                                                        <b-form-input v-model="customerDetails.bvn_first_name" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                <b-form-group label="Last Name" label-for="normalPass">
                                                        <b-form-input  v-model="customerDetails.bvn_last_name" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="BVN" label-for="normalPass">
                                                        <b-form-input  v-model="customerDetails.bvn_number" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="BVN Phone Number" label-for="normalEmail">
                                                        <b-form-input  v-model="formDetails.bvn_phone_number" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                <b-form-group label="BVN Date of Birth" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.bvn_dob" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </b-list-group><br/>
                                    <b-list-group>
                                        <b-list-group-item active>Personal Information</b-list-group-item>
                                        <b-list-group-item >
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="First Name" label-for="normalEmail">
                                                        <b-form-input v-model="customerDetails.first_name" type="text" ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                <b-form-group label="Last Name" label-for="normalPass">
                                                        <b-form-input v-model="customerDetails.last_name" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                <b-form-group label="Personal Email" label-for="normalPass">
                                                        <b-form-input v-model="userDetails.email" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Work Email" label-for="normalEmail">
                                                        <b-form-input v-model="formDetails.work_email" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Telephone" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.telephone" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Gender" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.gender" type="text" ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Marital Status" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.marital_status" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                <b-form-group label="Date of Birth" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.date_of_birth" type="date" ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="City Of Residence" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.city_of_residence" type="text" ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="State of Residence" label-for="normalEmail">
                                                        <b-form-input v-model="formDetails.state_of_residence" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Number of children" label-for="normalEmail">
                                                        <b-form-input v-model="formDetails.no_of_children" type="number"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="12" md="12" sm="12" xs="12">
                                                    <b-form-group label="Address" label-for="normalEmail">
                                                        <b-form-input v-model="formDetails.address" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row><br/>
                                        </b-list-group-item>
                                    </b-list-group><br/>
                                    <b-list-group>
                                        <b-list-group-item active>Employment Information</b-list-group-item>
                                        <b-list-group-item >
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Employment Status" label-for="input-4">
                                                        <select v-model="formDetails.employment_status" class="form-control" :required="true">
                                                            <option value="">---select employment status---</option>
                                                            <option value="employed" :selected="formDetails.employment_status === 'employed'">Employed</option>
                                                            <option value="self-employed" :selected="formDetails.employment_status === 'self-employed'">Self-employed</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Employment Type" label-for="input-4">
                                                        <select v-model="formDetails.employment_type" class="form-control">
                                                            <option value="">---select employment status---</option>
                                                            <option value="contract" :selected="formDetails.employment_type === 'contract'">Contract</option>
                                                            <option value="full-time" :selected="formDetails.employment_type === 'full-time'">Full-Time</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Employer Sector" label-for="input-4">
                                                        <select v-model="formDetails.employer_sector" class="form-control">
                                                            <option value="">---select employer sector---</option>
                                                            <option value="public" :selected="formDetails.employer_sector === 'public'">Public Sector</option>
                                                            <option value="private" :selected="formDetails.employer_sector === 'private'">Private Sector</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Employer Industry" label-for="input-4">
                                                        <select v-model="formDetails.employer_industry" class="form-control">
                                                            <option value="">---select employer industry---</option>
                                                            <option value="Financial Service" :selected="formDetails.employer_industry === 'Financial Service'">Financial Service</option>
                                                            <option value="Construction/Real Estate" :selected="formDetails.employer_industry === 'Construction/Real Estate'">Construction/Real Estate</option>
                                                            <option value="Manufacturing" :selected="formDetails.employer_industry ==='Manufacturing'">Manufacturing</option>
                                                            <option value="Industrial/Consumer goods" :selected="formDetails.employer_industry ==='Industrial/Consumer goods'">Industrial/Consumer goods</option>
                                                            <option value="Health Care" :selected="formDetails.employer_industry ==='Health Care'">Health Care</option>
                                                            <option value="ICT" :selected="formDetails.employer_industry ==='ICT'">ICT</option>
                                                            <option value="Oil and Gas" :selected="formDetails.employer_industry ==='Oil and Gas'">Oil and Gas</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Employer Name" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.employer_name" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="IPPIS Number" label-for="normalEmail" v-if="customerDetails.employer_sector === 'public'">
                                                        <b-form-input v-model="formDetails.ippis_number" type="text"></b-form-input>
                                                    </b-form-group>
                                                    <b-form-group label="Employment Number" label-for="normalPass" v-else-if="customerDetails.employer_sector === 'private'">
                                                        <b-form-input v-model="formDetails.employment_number" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Date of Employment" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.date_of_employment" type="date"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group  label="Employer City" label-for="input-4">
                                                        <b-form-input v-model="formDetails.employer_city" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group  label="Employer State" label-for="input-4">
                                                        <b-form-input v-model="formDetails.employer_state" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Address " label-for="input-4" description="Employer Address">
                                                        <b-form-input
                                                        v-model="formDetails.employer_address"
                                                        type="text"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Landmark " label-for="input-4" description="Employer landmark">
                                                        <b-form-input
                                                        v-model="formDetails.employer_landmark"
                                                        type="text"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Net Earnings(₦)" label-for="input-10" description="">
                                                        <b-form-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="formDetails.net_earnings"
                                                        :required="true"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Gross Earnings(₦)" label-for="input-10" description="">
                                                        <b-form-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="formDetails.gross_earnings"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </b-list-group><br/>
                                    <b-list-group v-if="customerDetails.business_name !== null">
                                        <b-list-group-item active>Business Information</b-list-group-item>
                                        <b-list-group-item>
                                            <b-row>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business Name" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.business_name" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business Email" label-for="normalEmail">
                                                        <b-form-input  v-model="formDetails.business_email" type="email"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business Address" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.business_address" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="RC Number" label-for="normalEmail">
                                                        <b-form-input  v-model="formDetails.rc_number" type="email"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Date of Corporation" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.date_of_corporation" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business Industry" label-for="normalEmail">
                                                        <b-form-input  v-model="formDetails.business_industry" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business State" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.business_state" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business City" label-for="normalEmail">
                                                        <b-form-input  v-model="formDetails.business_city" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Business Website" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.business_website" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </b-list-group><br/>
                                    <b-list-group>
                                        <b-list-group-item active>Next of Kin Information</b-list-group-item>
                                        <b-list-group-item >
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="NOK Name" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.nok_full_name" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="NOK EMail Address" label-for="normalEmail">
                                                        <b-form-input  v-model="formDetails.nok_email" type="email"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="NOK Address" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.nok_address" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="NOK Telephone" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.nok_phone_number" type="text"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Relationship with NOK" label-for="normalEmail">
                                                        <select v-model="formDetails.nok_relationship" class="form-control" id="input-2" required>
                                                            <option value="">---select--</option>
                                                            <option value="child" :selected="formDetails.nok_relationship === 'child'">Child</option>
                                                            <option value="parent" :selected="formDetails.nok_relationship === 'parent'">Parent</option>
                                                            <option value="spouse" :selected="formDetails.nok_relationship === 'spouse'">Spouse</option>
                                                            <option value="friend" :selected="formDetails.nok_relationship === 'friend'">Friend</option>
                                                            <option value="extended family" :selected="formDetails.nok_relationship === 'extended family'">Extended Family</option>
                                                            <option value="sibling" :selected="formDetails.nok_relationship === 'sibling'">Sibling</option>
                                                            <option value="others" :selected="formDetails.nok_relationship === 'others'">Others</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </b-list-group><br/>
                                    <b-list-group>
                                        <b-list-group-item active>Bank Account Information</b-list-group-item>
                                        <b-list-group-item >
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Account Name" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.account_name" type="text" :disabled="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Account Number" label-for="normalEmail">
                                                        <b-form-input  min="10" max="10" v-model="formDetails.account_number" type="text" :disabled="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Bank Name" label-for="normalPass">
                                                        <b-form-input  v-model="formDetails.bank_name" type="text" :disabled="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Bank Code" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.bank_code" type="text" :disabled="true"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="8" md="8" sm="12" xs="12">
                                                    <b-form-group label="Recipient Code" label-for="normalPass">
                                                        <b-form-input v-model="formDetails.recipient_code" type="text" :disabled="true"></b-form-input>
                                                    </b-form-group>
                                                    <div v-if="formDetails.recipient_code === null">
                                                        <span v-if="generating"><i class="fa fa-spinner fa-spin"></i> please wait ...</span>
                                                        <button title="Click here to generate recipient code" v-else @click="getRecipientCode" type="button" class="btn btn-sm btn-default" ><i class="fa fa-refresh"></i> Generate recipient code</button>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </b-list-group>
                            </b-col>
                        </b-row><hr/>
                            <b-button-group>
                                <b-button @click="goBack">Go Back</b-button>
                                <div v-if="access.includes(role)">
                                    <b-button type="button" variant="success" v-if="formLoading" disabled>
                                        <i class="fa fa-spinner fa-spin"></i> 
                                        Updating...
                                    </b-button>
                                    <b-button type="submit" variant="success" v-else>
                                        <i class="fa fa-cog"></i> 
                                        Update Profile
                                    </b-button>
                                </div>
                            </b-button-group>
                        </form>
                    </b-card>
                </div>
            </b-col>
        </b-row>
        <b-modal id="modal-1" title="Login Details" hide-footer>
            <form @submit="updateUserDetails">
                <div class="form-group">
                    <label>Email Address</label>
                    <input type="email" v-model="userDetails.email" class="form-control" />
                    <span style="font-size: 12px;color: red">Please be aware that this email address is used during login, so whatever changes you make here will affect the login of this user.</span>
                </div>
                <div class="form-group">
                    <label>First Name</label>
                    <input type="text" v-model="userDetails.first_name" class="form-control" />
                </div>
                <div class="form-group">
                    <label>Last Name</label>
                    <input type="text" v-model="userDetails.last_name" class="form-control" />
                </div>
                <b-button variant="success" v-if="changing" class="mt-3" block disable>
                    <i class="fa fa-spinner fa-spin"></i> processing ...
                </b-button>
                <b-button v-else variant="success" type="submit" class="mt-3" block>Save Changes</b-button>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { baseURL, URL } from '@/shared/utils';
import { getSingle, updatePhoto } from '@/services/customerService';
import { updateUser } from '@/services/userService';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'Customer',
    data() {
        return {
            userDetails: {},
            customerDetails: {},
            profile_image: '',
            formDetails: {},
            loading: false,
            generating: false,
            sending: false,
            changing: false,
            role: '',
            access: ['administrator','risk']
        }
    },
    computed: {
        ...mapState([
            'formLoading',
            'roles',
            'error'
        ]),
        ...mapGetters([
            'hasError'
        ])
    },
    beforeMount() {
        this.getCustomerDetails(this.$route.params.id);
    },
    created() {
        this.role = this.roles[0].name;
    },
    methods: {
        ...mapActions([
            'updateCustomer'
        ]),
        goBack() {
            this.$router.go(-1)
        },
        async getCustomerDetails(id) {
            this.loading = true;
            try {
                const { data: { user } } = await getSingle(id);
                const res = await this.$http.get(`${baseURL}user/${user.user_id}`);
                this.userDetails = res.data.user;
                this.profile_image = `${URL}${res.data.user.profile_image}`;
                this.customerDetails = user;
                this.formDetails = user;
                this.loading = false;
            } catch (err) {}
        },
        async updateCustomerDetails() {
           const result = await this.updateCustomer(this.formDetails);
           if(result) this.$swal('Updated Successfully!','Customer profile has been updated.','success');
        },
        async getRecipientCode() {
            this.generating = true;
            try {
                const { recipient_code, account_number, bank_name, id, bank_code } = this.customerDetails;
                if (account_number === null || bank_name === null || bank_code === null) {
                    this.$swal('Invalid request','Customer\'s bank details is incomplete. We can\'t proceed with this request','error');
                    return;
                }

                await updatePhoto(id, {
                    bank_name: bank_name,
                    account_number: account_number,
                    bank_code: bank_code,
                });
                this.$swal('Successful','Customer recipient code has been generated successfully.','success');
                window.location.reload();
            }
            catch(err) {
                console.log(err)
                this.$swal('Something went wrong',`${JSON.stringify(err)}`,'error');
            }
            finally {
                this.generating = false;
            }
        },
        async resendActivation() {
            this.sending = true;
            try {}
            catch(err) {}
        },
        async updateUserDetails(e) {
            e.preventDefault();
            this.changing = true;
            try {
                await updateUser(this.userDetails.id, {
                    email: this.userDetails.email,
                    first_name: this.userDetails.first_name,
                    last_name: this.userDetails.last_name
                });

                this.$swal('Updated Successfully!','User details has been updated.','success');
                this.$bvModal.hide('modal-1');
            }
            catch (err) {
                console.log(err)
            }
            finally {
                this.changing = false;
            }
        }
    }
}
</script>
